import { ascending, descending } from 'd3';
import UNCRPD from '../data/UNCRPD.json';
import DATA from '../data/AllProvinces.json';
import PROGRAMS from '../data/programDescriptions.json';
import POPULATIONS from '../data/CanadaPopulationData.json';

export default class DataManager {
  constructor() {
    this.data = DATA;
    this.populations = POPULATIONS;
    this.uncrpd = UNCRPD;
    this.programs = PROGRAMS.programs;
  }

  getProgramData(programName, province) {
    const programData = this.programs.filter((val) => {
      const isSelectedProgram = val.name.trim() === programName.trim() && 
        val.province.trim() === province.trim();
      return isSelectedProgram;
    });
    
    return programData.pop();
  }

  processData(provinces, yearRange, unit, type) {
    let data = this.data;
    const [min, max] = yearRange;
    const component = unit === 'expenditures' ? 'Expenditure' : 'Caseload';
    
    data = data.filter(val => {
      if (!provinces.includes(val.province)) return false;
      else if (!(min <= val.year && max >= val.year)) return false;
      else if (component !== val.pComponent) return false;
      else return true;
    });

    if (provinces.length > 1) {
      data = this.groupBy(data, 'province');
    } else {
      data = this.groupBy(data, type);
    }

    this.line = data.map(val => val.time);
    this.line.sort((a, b) => descending(a.total, b.total));
    this.line.forEach(val => {
      val.value = this.groupBy(val.value, 'year').map(d => {
        return {
          'year': parseInt(d.time.key),
          'value': d.time.total
        }
      });
    });

    if (provinces.length > 1 && unit === 'expenditures') {
      this.calcPerCapitaExpenditures(provinces);
    }
  }

  groupBy(data, property) {
    let aggregated = data.reduce((grp, val) => {
      const key = val[property];

      if (!grp[key]) grp[key] = {timeData: [], total: 0};
      if (!val.value >= 0) {
        grp[key].total += val.value;
        grp[key].timeData.push(val);
      }
      return grp
    }, {});

    aggregated = Object.entries(aggregated).map(([key, value]) => {
      return {
        grouped: {
          key,
          value: value.total
        },
        time: {
          key,
          total: value.total,
          value: value.timeData.sort((a, b) => ascending(a.year, b.year)),
        }
      };
    });

    return aggregated;
  }

  calcPerCapitaExpenditures() {
    this.line.forEach(val => {
      const prov = val.key;
      const provPop = this.populations.filter(val => prov === val.province);
      val.value.forEach(d => {
        const yearsPop = provPop.filter(yearlyPop => yearlyPop.year === d.year);
        const population = yearsPop.pop().population;
        d.value = d.value / population * 1000000;
      });
    });
  }
}